<template>
  <div
    v-if="currentUser?.emailVerified"
    id="layout"
    class="layout"
  >
    <Header />
    <Alert />
    <div class="inner-wrapper">
      <div
        id="innerBanner"
        class="inner-banner"
      >
        <SubscriptionBanner
          v-if="showSubscriptionBanner"
          :trialEndDate="trialEndDate"
        />
      </div>
      <div
        id="mainContent"
        :key="forceUpdateLayout"
        class="inner"
      >
        <router-view />
      </div>
      <div id="toDoWidget" />
    </div>
    <Footer />
    <Teleport to="body">
      <UpgradePlanWithoutPermission />
    </Teleport>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Watch } from "vue-property-decorator"
import { useAcl } from "vue-simple-acl"
import { Getter } from "s-vuex-class"

import Alert from "@/components/Alert/index.vue"
import Footer from "@/components/Footer/index.vue"
import Header from "@/components/Header/index.vue"
import UpgradePlanWithoutPermission from "@/components/Modal/UpgradePlanWithoutPermission.vue"
import SubscriptionBanner from "@/components/Subscription/SubscriptionBanner.vue"

import { Account, User } from "@/models"
import { Getters } from "@/store/getters"

@Options({
  components: {
    Header,
    Alert,
    Footer,
    SubscriptionBanner,
    UpgradePlanWithoutPermission
  },
  name: "DefaultLayout"
})
export default class App extends Vue {
  @Getter(Getters.GET_ACCOUNT) account: Account
  @Getter(Getters.GET_USER_CURRENT_PROFILE) readonly currentUser: User

  forceUpdateLayout = 0

  get trialEndDate() {
    return this.account?.paymentSubscription?.trialEndDate
  }

  get showSubscriptionBanner() {
    if (
      !this.trialEndDate ||
      !useAcl().can("isTrial") ||
      !this.$route.params.accountId ||
      useAcl().can("superAdmin")
    )
      return false
    return !!this.currentUser.settings?.showEndTrialPeriod
  }

  get triggerUpdate() {
    return this.$route?.meta?.updateComponentByRoute
      ? decodeURI(this.$route.path).replace(/\s/g, "")
      : ""
  }

  @Watch("triggerUpdate")
  onTriggerUpdateChange() {
    if (this.$wait.is("disableUpdateComponentByRoute")) return
    this.forceUpdateLayout++
  }
}
</script>
